angular.module('rjmNg.api').factory("Journal", [
  "$resource"
  "phpServiceUrl"
  ($resource, phpServiceUrl) ->
    Journal = $resource(phpServiceUrl("/journal"))
  ]
)
